import {getToken} from "../auth/service/authService";
import {Organization, OrgUpdateData} from "../models/Organization";
import axios from "axios";
import {BackendUrl} from "../util/config";

const API_BASE = BackendUrl

export async function fetchOrganizationById(orgId: string): Promise<Organization> {
    const token = getToken();
    const response = await axios.get<Organization>(`${API_BASE}/organizations/${orgId}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
}

export async function fetchMyOrganization(): Promise<Organization | null> {
    const token = getToken();
    try {
        const response = await axios.get<Organization>(`${API_BASE}/organizations/my-organization`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    }
    catch (err){
        return null
    }


}

export interface CreateOrganizationData {
    name: string;
    street: string;
    city: string;
    state: string;
    zip: string;
    country: string;
}

// Example: create a new organization on the server
export async function createOrganization(
    data: CreateOrganizationData
) {
    const token = getToken();

    const response = await axios.post(
        `${API_BASE}/organizations`,
        data,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
    // Typically returns the created Organization from the backend
    // Adjust if your backend returns different fields
}

// 2) Update an organization's attributes
export async function updateOrganization(organizationId: string, updateData: OrgUpdateData): Promise<void> {
    try {
        await axios.put(`${API_BASE}/organizations/${organizationId}`, updateData, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        });
    } catch (err) {
        console.error("Error updating organization:", err);
        throw err;
    }
}